// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"3":"927c0da64ac65d5b1d53","511":"b8d43c8383f90d565c6a","515":"a2ee7c82bb389dcd1a5d","798":"ec11125429aba90e12f2"}[chunkId] + ".js";
};